<template>
	<div id="kcshanglei">

		<div class="fflex ffbet" style="margin-bottom: 10px">
			<ul class="fflex headBox">
				<li class="active">库存列表</li>
<!--				<li @click="jump('kcbaobiao')">库存报表</li>-->
				<li @click="jump('kcpand')">盘点单</li>
				<li @click="jump('kcchuru')">出入库明细</li>

			</ul>
			<div class=" ">
				<el-select size="small" style="width: 150px;margin-right: 10px" v-model="type_id" placeholder="选择商品类别">
					<el-option v-for="item in goodsleiop" :key="item.id" :label="item.type_name" :value="item.id">
					</el-option>
				</el-select>

				<el-input size="small" v-model="search" placeholder="输入商品名称" @keyup.enter.native="chaxun" style="width: 150px;margin-right: 10px"></el-input>
				<el-button type="success" size="mini" @click="chaxun">查询</el-button>
			</div>
		</div>

		<!--<div class="fflex ffend" style="margin: 10px 0;line-height: 32px;color: #999">-->

		<!--<el-select size="small" style="width: 150px;margin-right: 10px"  v-model="goodslei" placeholder="选择商品类别">-->
		<!--<el-option-->
		<!--v-for="item in goodsleiop"-->
		<!--:key="item.value"-->
		<!--:label="item.label"-->
		<!--:value="item.value">-->
		<!--</el-option>-->
		<!--</el-select>-->

		<!--<el-input size="small" placeholder="输入商品名称" style="width: 150px;margin-right: 10px"></el-input>-->
		<!--<el-button type="success"  size="mini" >查询</el-button>-->

		<!--</div>-->


		<div class="tableBox">
			<table class="table table-bordered">
				<thead>
					<tr>
						<th>序号</th>
						<th>商品编号</th>
						<th>商品名称</th>
						<th>图片</th>
						<th>商品类别</th>
						<th>商品规格</th>
						<th>单位</th>
						<th>当前库存</th>
<!--						<th>库存金额</th>-->
					</tr>
				</thead>
				<tbody>
					<tr v-for="(ta,taindex) in tabledata" :key="taindex">
						<td>{{taindex+1}}</td>
						<td>{{ta.good_num}}</td>
						<td>{{ta.good_name}}</td>
						<td><img class="miniimg" :preview="taindex+1" :src="ta.imgpath" alt=""></td>
						<td>{{ta.type_name}}</td>
						<td>{{ta.spec}}</td>
						<td>{{ta.unit}}</td>
						<td>{{ta.number}}</td>
<!--						<td>{{ta.stock_sum_price}}</td>-->


					</tr>

				</tbody>
			</table>
			<p>共有{{total}}条记录 当前{{currentpage}}页/共{{pagetotal}}页</p>
		</div>

		<div class="table-bottom">
			<div>
				<el-pagination @current-change="handleCurrentChange" :current-page="currentpage" :page-size="pageone" background
				 layout="prev, pager, next" :total="total">
				</el-pagination>
			</div>
		</div>







	</div>
</template>

<script>
	export default {
		data() {
			return {
				token: '',
				gyshang: '',
				currentpage: 1,
				pageone: 10,
				total: 100,
				kcshangleit: false,
				zhuang: '',
				Ttitle: '',
				dis: false,
				//            shangphone:''
				goodsleiop: [{
					value: '',
					label: '请选择'
				}, {
					value: '195',
					label: '非消耗品'
				}, {
					value: '196',
					label: '日常消耗品'
				}, {
					value: '197',
					label: '固定资产'
				}],
				type_id: '',
				search: '',
				tabledata: "",
				pagetotal: 0



			};
		},
		methods: {


			chaxun: function() {
				var self = this;
				self.currentpage = 1
				self.gonggong()

			},
			handleCurrentChange: function(i) {
				var self = this;
				self.currentpage = i
				self.gonggong()
			},

			jump: function(e) {
				this.$router.push({
					'name': e
				})
			},
			gonggong: function() {
				var self = this;
				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + 'saas/JxcStock/index',
					dataType: 'json',
					data: {
						page: self.currentpage,
						token: self.token,
						search: self.search,
						type_id: self.type_id
					},
					success: function(data) {
						if (data.stauts == 1) {

							self.tabledata = data.data;

							self.total = Number(data.map.count)
							self.currentpage = Number(data.map.page)
							self.pagetotal = Number(data.map.pagetotal)
							self.goodsleiop = [{
								id: "",
								type_name: "请选择"
							}, ...data.types]
						} else {
							self.tabledata = '';
							self.total = 0;
							self.pagetotal = 1;
							self.currentpage = 1
						}

					}
				})
			}


		},
		mounted: function() {
			var self = this;
			self.token = $.cookie('token');
			self.gonggong()


		}


	}
</script>

<style scoped>
	.xiala {
		width: 200px;
		height: 32px;
		line-height: 32px;
		background-color: #fff;
		background-image: none;
		border-radius: 4px;
		border: 1px solid #dcdfe6;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		color: #606266;
		display: inline-block;
		font-size: 13px;
		outline: 0;
		padding: 0 15px;
		-webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
		transition: border-color .2s cubic-bezier(.645, .045, .355, 1);

	}

	.miniimg {
		width: 25px;
		height: 25px;
	}

	.yulantu {
		width: 100px;
		height: 100px;
		border-radius: 6px;
		margin-left: 10px;
	}

	ul {
		list-style: none;
	}

	#kcshanglei p,
	label,
	ul {
		margin: 0;
		padding: 0;
	}

	.fflex {
		display: flex;
		display: -webkit-flex;
	}

	.ffbet {
		justify-content: space-between;
	}

	.ffend {
		justify-content: flex-end;
	}

	#kcshanglei * {
		box-sizing: border-box;
	}

	#kcshanglei {
		box-sizing: border-box;
		padding: 10px;
	}

	.headBox li {
		width: 75px;
		background: #8CBB77;
		height: 30px;
		line-height: 30px;
		margin-right: 8px;
		border-radius: 5px 5px 0 0;
		text-align: center;
		color: #fff;

	}

	.headBox li.active {
		background: #ecebfd;
		color: #8CBB77;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .2);
	}

	.purBtnsz {
		background: #8CBB77 !important;
		height: 26px;
		border: none !important;
	}

	.marBo2 {
		margin-bottom: 10px;
	}

	.inputT {
		display: inline-block;
		width: 100px;

	}
</style>
<style>


</style>



// WEBPACK FOOTER //
// src/pages/jinxc/kcshanglei.vue